﻿import { mapGetters, mapState } from 'vuex';
import UpgradedSpeedItem from './UpgradedSpeedItem.js';

export default {
name: 'upgraded-speed',
computed:         
        Object.assign(
            mapGetters({
                otherVariants: 'otherVariants',
                selectedVariant: 'selectedVariant'
            }),
            {
    
                availableBoosts() {
                    let boosts = [];
                    if(!this.otherVariants || !this.selectedVariant) return boosts;
                    for (var i = 0; i < this.otherVariants.length; i++) {
                        if(this.selectedVariant.speedDown < this.otherVariants[i].speedDown)
                            if(this.selectedVariant.numberOfVas === this.otherVariants[i].numberOfVas)
                                boosts.push(this.otherVariants[i]);
                    }
                    return boosts;
                }
            }),
components: {
    'upgraded-speed-item' : UpgradedSpeedItem
},
props: ['variants', 'product'],
    methods: {
        selectVariant(installationFeeCode, activationFeeCode, productCode, variantCode) {
            //this.$store.dispatch('selectVariant', {activationFeeCode: activationFeeCode, productCode: productCode, variantCode: variantCode });
            this.$emit('select', 'This can be w/e')
        }
    }
}
